export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "Resource3DPreview.worker.bf51c3b4bf3046ded6d1.worker.js");
}
